export const requiredHeaders = ['Authorization'];
export const RESOURCES = {
  projects: 'projects',
  'draft-projects': 'draft-projects',
  topics: 'topics',
  routes: 'routes',
  priorizaciones: 'priorizaciones',
  disclaimers: 'disclaimers',
  etapas: 'etapas',
  'tipos-proyecto': 'tipos-proyecto',
  alcances: 'alcances',
  'estados-estudios': 'estados-estudios',
  estados: 'estados',
  'financiadores-estudios': 'financiadores-estudios',
  sectores: 'sectors',
  subsectores: 'subsectores',
  paises: 'countries',
  metrics: 'metrics',
  'metric-values': 'metric-values',
  countries: 'countries',
  layers: 'layers',
  users: 'users',
};

export const defaultListProps = { bulkActionButtons: false };
